import React, { useMemo, useState } from "react";
import { useTranslation } from "../i18n";

import { useNavigate } from "react-router-dom";

// const stats = [
//   {
//     title: "Logged hours",
//     value: "3,842 h",
//     description: "6.4% vs last month",
//     growth: "up",
//     colorClass: "orange",
//     icon: "/assets/totalrevenue.svg",
//   },
//   {
//     title: "Active today",
//     value: "46",
//     description: "12 currently tracking",
//     growth: "up",
//     colorClass: "green",
//     icon: "/assets/activetoday.svg",
//   },
//   {
//     title: "Pending review",
//     value: "18",
//     description: "6 need admin approval",
//     growth: "up",
//     colorClass: "blue",
//     icon: "/assets/pendingreview.svg",
//   },
//   {
//     title: "Overtime alerts",
//     value: "7",
//     description: "2 high priority",
//     growth: "down",
//     colorClass: "red",
//     icon: "/assets/overtimealerts.svg",
//   },
// ];

const stats = [
  {
    title: "Logged hours",
    value: "3,842 h",
    change: "+12.8% vs last month",
    icon: "/assets/totalrevenue.svg",
    color: "gold",
  },
  {
    title: "Active today",
    value: "95",
    change: "+8.4% vs last month",
    icon: "/assets/activetoday.svg",
    color: "blue",
  },
  {
    title: "Pending review",
    value: "14",
    change: "3 high priority",
    icon: "/assets/pendingreview.svg",
    color: "red",
  },
  {
    title: "Overtime alerts",
    value: "7",
    change: "+6.2% vs last month",
    icon: "/assets/overtimealerts.svg",
    color: "green",
  },
];
const transactionRows = [
  {
    id: 1,
    user: "Maya Chen",
    operation: "OP-001284",
    task: "Shipment coordination",
    date: "17 Aug",
    hours: "7h 30m",
    reviewer: "A. Meian",
    status: "Approved",
    statusClass: "approved",
  },
  {
    id: 2,
    user: "Daniel Owusu",
    operation: "OP-001283",
    task: "Buyer documentation",
    date: "17 Aug",
    hours: "6h 45m",
    reviewer: "—",
    status: "Pending",
    statusClass: "pending",
  },
  {
    id: 3,
    user: "Sara Ibrahim",
    operation: "OP-001282",
    task: "Payment reconciliation",
    date: "16 Aug",
    hours: "8h 10m",
    reviewer: "A. Meian",
    status: "Approved",
    statusClass: "approved",
  },
  {
    id: 4,
    user: "Noah Mensah",
    operation: "OP-001281",
    task: "Compliance review",
    date: "16 Aug",
    hours: "9h 05m",
    reviewer: "R. Khan",
    status: "Pending",
    statusClass: "pending",
  },
  {
    id: 5,
    user: "Lina Costa",
    operation: "OP-001280",
    task: "Seller onboarding",
    date: "15 Aug",
    hours: "5h 40m",
    reviewer: "R. Khan",
    status: "Approved",
    statusClass: "approved",
  },
];

export default function Transactions() {
  const { t, text, status: translateStatus } = useTranslation();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("30");
  const filteredTransactions = useMemo(() => {
    const searchValue = search.trim().toLowerCase();

    return transactionRows.filter((item) => {
      const matchesSearch =
        !searchValue ||
        item.user?.toLowerCase().includes(searchValue) ||
        item.operation?.toLowerCase().includes(searchValue) ||
        item.task?.toLowerCase().includes(searchValue) ||
        item.date?.toLowerCase().includes(searchValue) ||
        item.hours?.toLowerCase().includes(searchValue) ||
        item.reviewer?.toLowerCase().includes(searchValue) ||
        item.status?.toLowerCase().includes(searchValue);

      const matchesStatus = !statusFilter || item.status === statusFilter;

      return matchesSearch && matchesStatus;
    });
  }, [search, statusFilter]);

  return (
    <div className="dashboard-page inquiries-page">
      <div className="inquiries-page-header">
        <div>
          <h1 className="f-s-28 l-h-32 fw-semibold">{t("ui.transactions")}</h1>

          <p className="f-s-14 l-h-20">{t("ui.monitor.team.working.hours.time.entries.and.approvals.across.operations")}</p>
        </div>
      </div>
      <div className="container-fluid px-0">
        <div className="row g-3">
          {stats.map((stat, index) => (
            <div
              className="col-md-3"
              key={index}
            >
              {/* <div className="operation-stat-card h-100">
                <div className={`operation-stat-icon ${stat.colorClass}`}>
                  <img src={stat.icon} alt="" />
                </div>

                <div className="operation-stat-content">
                  <span className="operation-stat-title">{text(stat.title)}</span>

                  <strong className="operation-stat-value">{stat.value}</strong>

                  <span
                    className={`operation-stat-growth ${
                      stat.growth === "up" ? "positive" : "negative"
                    }`}
                  >
                    <span className="growth-arrow">
                      {stat.growth === "up" ? "↗" : "↘"}
                    </span>

                    {text(stat.description)}
                  </span>
                </div>
              </div> */}
               {/* <div className="overview-stat-card">
              <div className={`overview-stat-icon ${stat.color}`}>
                <span
                  className={`overview-stat-icon-img ${stat.color}`}
                  style={{
                    "--icon-url": `url(${stat.icon})`,
                  }}
                />
              </div>

              <div className="overview-stat-content">
                <span className="overview-stat-title">{text(stat.title)}</span>

                <div className="overview-stat-bottom">
                  <strong>{stat.value}</strong>
                  <small className={stat.color}>{text(stat.change)}</small>
                </div>
              </div>
            </div> */}
            </div>
          ))}
        </div>
      </div>
      <div className="inquiries-table-card">
        <div className="inquiries-table-header">
          <div>
            <h2>{t("ui.recent.time.entries")}</h2>

            <p>{t("ui.view.and.manage.recent.team.time.entries")}</p>
          </div>

          <div className="inquiries-table-actions">
            {/* Search */}
            <div className="inquiries-search">
              <img src="/assets/search-icon.svg" alt="" />

              <input
                type="text"
                placeholder={t("ui.search.entries")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {search && (
                <button type="button" onClick={() => setSearch("")}>
                  ×
                </button>
              )}
            </div>

            {/* Status filter */}
            <div className="inquiries-status-filter">
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">{t("ui.all.status.16175ap")}</option>

                <option value="Approved">{t("ui.approved")}</option>

                <option value="Pending">{t("ui.pending")}</option>
              </select>
            </div>
          </div>
        </div>
        <div className="inquiries-table-wrapper">
          <table className="inquiries-modern-table operations-modern-table">
            <thead>
              <tr>
                <th>{t("ui.user")}</th>

                <th>{t("ui.operation")}</th>

                <th>{t("ui.task.activity")}</th>

                <th>{t("ui.date.19hvy")}</th>

                <th>{t("ui.hours")}</th>

                <th>{t("ui.reviewer")}</th>

                <th>{t("ui.status")}</th>

                {/* <th className="inquiry-actions-heading">
                  Actions
                </th> */}
              </tr>
            </thead>

            <tbody>
              {filteredTransactions.length > 0 ? (
                filteredTransactions.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <div className="transaction-user-cell">
                        <strong>{item.user}</strong>
                      </div>
                    </td>
                    <td>
                      <span className="transaction-operation-id">
                        {item.operation}
                      </span>
                    </td>
                    <td>
                      <div className="transaction-task-cell">{item.task}</div>
                    </td>
                    <td>
                      <span className="transaction-date">{item.date}</span>
                    </td>
                    <td>
                      <strong className="transaction-hours">
                        {item.hours}
                      </strong>
                    </td>
                    <td>
                      <span className="transaction-reviewer">
                        {item.reviewer}
                      </span>
                    </td>
                    <td>
                      <div className="operation-stage-cell">
                        <span
                          className={`operation-stage-status ${item.statusClass}`}
                        >
                          {translateStatus(item.status)}
                        </span>
                      </div>
                    </td>
                    {/* <td>
                      <div className="operation-table-actions">
                        <button
                          type="button"
                          className="operation-view-btn"
                          title="View details"
                          onClick={() =>
                            navigate(
                              `/transactions/${item.id}`
                            )
                          }
                        >
                          <img
                            src="/assets/eye.svg"
                            alt="View"
                          />
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">
                    <div className="inquiries-empty-state">
                      <img src="/assets/search-icon.svg" alt="" />

                      <strong>{t("ui.no.transactions.found")}</strong>

                      <span>{t("ui.try.changing.your.search.or.filters")}</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="inquiries-table-footer">
          <span>{t("ui.showing")}{" "}{filteredTransactions.length > 0 ? 1 : 0}
            {" to "}
            {filteredTransactions.length}
            {" of "}
            <strong>{transactionRows.length}</strong>
            {" entries"}
          </span>

          <div className="inquiries-pagination">
            <button type="button">‹</button>

            <button type="button" className="active">
              1
            </button>

            <button type="button">2</button>

            <button type="button">3</button>

            <button type="button">›</button>
          </div>
        </div>
      </div>
    </div>
  );
}
